import React, { useState } from 'react';
import { Link } from 'gatsby';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { reportData } from '../services/dataReport';

import * as styles from './ClassMenu.module.css';
import { activitiesTypeObject } from '../utils/constants';

const ClassMenu = ({ lesson, contentfulId, userId }) => {
  const [openLesson, setOpenLesson] = useState(true);
  const [openActivity, setOpenActivity] = useState(true);
  const [activeMenus, setActiveMenus] = useState(null);

  const handleClickActive = (index, name) => {
    setActiveMenus(index === activeMenus ? null : index);

    reportData(userId, 'selectedClassSite', `${contentfulId}?content=${name}`);
  };

  const handleClickLesson = () => {
    setOpenLesson(!openLesson);
  };

  const handleClickActivity = () => {
    setOpenActivity(!openActivity);
  };

  const {
    childrenContentfulAulaActiveMethodologiesJsonNode: activeMethodologies,
  } = lesson;

  const openActivityDinamic =
    lesson.closedExercise?.childMarkdownRemark?.html ||
    lesson?.closedExerciseImages
      ? '2'
      : '1';

  return (
    <List
      sx={{ width: '100%', maxWidth: 450 }}
      style={{ background: '#FFFFFF' }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader
          component="div"
          id="nested-list-subheader"
          className={styles.subheader}
        >
          Menu desta aula
        </ListSubheader>
      }
    >
      <ListItemButton
        onClick={handleClickLesson}
        className={styles.listBtnPrimary}
      >
        <ListItemText primary="Aula" />
        {openLesson ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openLesson} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 4 }}
            component={Link}
            to={`/${lesson.urlSlug}/#introducao`}
            onClick={() => handleClickActive(0, 'introducao')}
            className={styles.listWrap}
          >
            <ListItemText
              secondary="Introdução"
              className={activeMenus === 0 ? styles.activeMenu : ''}
            />
          </ListItemButton>
          {lesson.videoContents && (
            <ListItemButton
              sx={{ pl: 4 }}
              component={Link}
              to={`/${lesson.urlSlug}/#material-apoio`}
              onClick={() => handleClickActive(1, 'material-apoio')}
              className={styles.listWrap}
            >
              <ListItemText
                secondary="Material de apoio"
                className={activeMenus === 1 ? styles.activeMenu : ''}
              />
            </ListItemButton>
          )}
        </List>
      </Collapse>

      <ListItemButton
        onClick={handleClickActivity}
        className={styles.listBtnPrimary}
      >
        <ListItemText primary="Atividades" />
        {openActivity ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openActivity} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className={styles.listContainer}>
          {(lesson.closedExercise?.childMarkdownRemark?.html ||
            lesson?.closedExerciseImages) && (
            <ListItemButton
              className={styles.listWrap}
              sx={{ pl: 4 }}
              component={Link}
              to={`/${lesson.urlSlug}/#multipla-escolha`}
              onClick={() => handleClickActive(2, 'multipla-escolha')}
            >
              <ListItemText
                secondary="1. Múltipla escolha"
                className={activeMenus === 2 ? styles.activeMenu : ''}
              />
            </ListItemButton>
          )}
          <ListItemButton
            className={styles.listWrap}
            sx={{ pl: 4 }}
            component={Link}
            to={`/${lesson.urlSlug}/#atividade-aberta`}
            onClick={() => handleClickActive(3, 'atividade-aberta')}
          >
            <ListItemText
              secondary={`${openActivityDinamic}. Atividade aberta`}
              className={activeMenus === 3 ? styles.activeMenu : ''}
            />
          </ListItemButton>
          {Array.isArray(activeMethodologies) &&
            activeMethodologies.length > 0 &&
            activeMethodologies.map((activeMethodology, index) => {
              const activityIndex = index + 4;
              const urlSlug =
                activitiesTypeObject[activeMethodology?.name?.toLowerCase()]
                  ?.urlSlug;

              const methodologyName = activeMethodology?.name?.toLowerCase();
              const methodologyTitle =
                activitiesTypeObject[methodologyName]?.title;
              const methodologyResult =
                activeMethodology && methodologyName
                  ? methodologyTitle
                    ? `${index + 3}. ${methodologyTitle}`
                    : ''
                  : '';

              return (
                <ListItemButton
                  key={index}
                  className={styles.listWrap}
                  sx={{ pl: 4 }}
                  component={Link}
                  to={`/${lesson.urlSlug}/#${urlSlug}`}
                  onClick={() => handleClickActive(activityIndex, urlSlug)}
                >
                  <ListItemText
                    secondary={`${methodologyResult}`}
                    className={
                      activeMenus === activityIndex ? styles.activeMenu : ''
                    }
                  />
                </ListItemButton>
              );
            })}
        </List>
      </Collapse>
    </List>
  );
};

export default ClassMenu;
